import { EntityModel } from '@/interfaces'
import {
  ALL_ROLES_QUERY,
  CREATE_ROLE_MUTATION,
  DELETE_ROLE_MUTATION,
  FORCE_DELETE_ROLE_MUTATION,
  SINGLE_ROLE_QUERY,
  UPDATE_ROLE_MUTATION,
} from './graphql'
import rbacPermissionEntity from '@/entities/rbacPermission/entity'

const rbacRoleModel: EntityModel = {
  name: 'role',
  namePlural: 'roles',
  uniqueName: 'rbacRole',
  uniqueNamePlural: 'rbacRoles',
  path: 'iam/rbac/role',
  baseUrl: '/iam/roles',
  translationPrefix: 'entities:rbacRole.',
  getDisplayName: (values: any) => {
    return values.name
  },
  gql: {
    getAll: ALL_ROLES_QUERY,
    getSingle: SINGLE_ROLE_QUERY,
    create: CREATE_ROLE_MUTATION,
    update: UPDATE_ROLE_MUTATION,
    delete: DELETE_ROLE_MUTATION,
    forceDelete: FORCE_DELETE_ROLE_MUTATION,
  },
  attributes: {
    name: {
      name: 'name',
      label: 'entities:rbacRole.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    description: {
      name: 'description',
      label: 'entities:rbacRole.attributes.description.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    permissions: {
      name: 'permissions',
      label: 'entities:rbacRole.attributes.permissions.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return rbacPermissionEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default rbacRoleModel
